export default {
  env: 'development',
  website: '45.149.77.35',
  apiServer: '45.149.77.35:7001',
  apiServer: '192.168.1.8:7001',
  staticServer: '45.149.77.35:86',
  aiEndpoint: 'http://194.62.43.5:8000/api/endpoint/',
  ssl: false,

  website: 'hooshmandteb.ir',
  apiServer: 'api.hooshmandteb.ir',
  staticServer: 'static.hooshmandteb.ir',
  ssl: true
}
